import React, { FunctionComponent, useState } from "react";
import styles from "./Footer.module.scss";
import imgPP from "../../assets/img/pp.png";
import imgMC from "../../assets/img/mc.png";
import imgAE from "../../assets/img/ae.png";
import imgVS from "../../assets/img/vs.png";

type ownProps = {};

const arrowDownIcon =
  '<svg t="1645153620957" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12442" width="32" height="32"><path d="M500.8 604.779L267.307 371.392l-45.227 45.27 278.741 278.613L779.307 416.66l-45.248-45.248z" p-id="12443" fill="#ffffff"></path></svg>';
const arrowUpIcon =
  '<svg t="1645153242103" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11980" width="32" height="32"><path d="M500.8 461.909333L267.306667 695.296l-45.226667-45.269333 278.741333-278.613334L779.306667 650.026667l-45.248 45.226666z" p-id="11981" fill="#ffffff"></path></svg>';

const footerItems = [
  {
    title: "About New Reg",
    items: [
      {
        content: "Blog & news",
        link: "https://www.newreg.co.uk/blog ",
      },
      {
        content: "DVLA information",
        link: "https://www.newreg.co.uk/number-plates-information/dvla-number-plates/",
      },
      {
        content: "Shipping policy",
        link: "https://www.newreg.co.uk/help/regulations/shipping-policy",
      },
      {
        content: "Returns policy",
        link: "https://www.newreg.co.uk/help/regulations/returns-policy",
      },
      {
        content: "Contact us",
        link: "https://www.newreg.co.uk/help/contact",
      },
    ],
  },
  {
    title: "Registration Types",
    items: [
      {
        content: "Private number plates",
        link: "https://www.newreg.co.uk/buy/private-number-plates/",
      },  
      {
        content: "Dateless number plates",
        link: "https://www.newreg.co.uk/buy/dateless-number-plates/",
      },
      {
        content: "Irish number plates",
        link: "https://www.newreg.co.uk/buy/irish-number-plates/",
      },
      {
        content: "Future release number plates",
        link: "https://www.newreg.co.uk/future-releases",
      },
      {
        content: "Private plates",
        link: "https://www.newreg.co.uk/buy/private-plates/",
      },        
      {
        content: "Prefix number plates",
        link: "https://www.newreg.co.uk/buy/prefix-number-plates/",
      },
      {
        content: "Current style registrations",
        link: "https://www.newreg.co.uk/buy/current-number-plates/",
      }
    ],
  },
  {
    title: "Helpful Links",
    items: [
      {
        content: "Number plate builder",
        link: "https://www.newreg.co.uk/number-plate-builder",
      },
      {
        content: "Number plate search",
        link: "https://www.newreg.co.uk/buy/number-plates-search.html",
      },
      {
        content: "Frequently asked questions",
        link: "https://www.newreg.co.uk/help/faqs",
      },
      {
        content: "Free valuation",
        link: "https://www.newreg.co.uk/valuations/newreg_valuations_form",
      },
      {
        content: "Retention scheme",
        link: "https://www.newreg.co.uk/services/retention_scheme",
      },
      {
        content: "Finance calculator",
        link: "https://www.newreg.co.uk/buy/number-plate-finance/",
      },
      {
        content: "My account",
        link: "https://www.newreg.co.uk/users",
      },
    ],
  },
  {
    title: "Registered Office",
    items: [
      {
        content: "New Reg Limited",
        class: "new-reg-limited",
      },
      {
        content: "Unit 5, 117 Liverpool Road",
      },
      {
        content: "Longton, Preston",
      },
      {
        content: "PR4 5AA",
      },
    ],
  },
];

const Footer: FunctionComponent<ownProps> = (props: ownProps) => {
  const [expandIndex, setExpandIndex] = useState(-1);

  return (
    <div className={styles.footer}>
      <section>
        <h2>
          NewReg.co.uk - The UK's most trusted private number plate supplier.
        </h2>
        <p style={{ fontSize: 12 }}>
          New Reg Limited are authorised and regulated by the Financial Conduct
          Authority (No. 626225).
        </p>
      </section>
      <div className={styles.contents}>
        <div className={styles.container} style={{ marginBottom: 20 }}>
          {footerItems.map((item, index) => {
            return (
              <div key={index} className={styles.footerItems}>
                <p
                  className={styles.footerItemsTitle + " " + index}
                  onClick={() => setExpandIndex(index)}
                >
                  <b>{item.title}</b>
                  <span className={styles.arrow}>
                    <span className={index === expandIndex ? "d-none" : ""}>
                      <span
                        dangerouslySetInnerHTML={{ __html: arrowDownIcon }}
                      ></span>
                    </span>
                    <span className={index === expandIndex ? "" : "d-none"}>
                      <span
                        dangerouslySetInnerHTML={{ __html: arrowUpIcon }}
                      ></span>
                    </span>
                  </span>
                </p>
                {(item.items as Array<any>).map((value, key) => {
                  return value["link"] ? (
                    <span
                      key={key}
                      className={
                        "item-list-" +
                        index +
                        " " +
                        styles.itemList +
                        (index === expandIndex ? "" : " hide-on-med-and-down")
                      }
                    >
                      <a href={value["link"]} target="_blank" rel="noreferrer">
                        {value["content"]}
                      </a>
                    </span>
                  ) : (
                    <span
                      className={
                        "item-list item-list-" +
                        index +
                        " " +
                        styles.itemList +
                        (index === expandIndex ? "" : " hide-on-med-and-down")
                      }
                      key={key}
                    >
                      {value["content"]}
                    </span>
                  );
                })}
              </div>
            );
          })}
          <div className={styles.aboutUs}>
            <p>
              <b>Secure, Established & Trusted.</b>
            </p>
            <span className="trusted">
              Established as a recognised DVLA reseller in 1991, by 1996 New Reg
              became the first company to sell private number plates online:
              Paving the way online for DVLA New Reg has become the firm
              favourite, for anyone buying or selling personalised number
              plates.
            </span>
          </div>
        </div>
        {/* follow us */}
        <div className={styles.container + " " + styles.followUsWrapper}>
          <div className={styles.followUsItems}>
            <span className="title">
              <strong>Follow us</strong>
            </span>
            <a
              target="_blank"
              href="https://twitter.com/new_reg"
              rel="noopener noreferrer"
              className="icon-twitter"
            >
              <svg
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1246"
                width="200"
                height="200"
              >
                <path
                  d="M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4 35.4-21.1 62.3-54.4 75-94-32.7 19.5-69.7 33.8-108.2 41.2C765.4 194.6 721.1 174 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5-14.8 25.4-23.2 54.4-23.2 86.1 0 59.2 30.1 111.4 76 142.1-28-1.1-54.4-9-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4-14.3 3.7-29.6 5.8-44.9 5.8-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-0.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-0.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z"
                  p-id="1247"
                  fill="#ffffff"
                ></path>
              </svg>
                Twitter
                
            </a>
            <a
              target="_blank"
              href="https://www.facebook.com/NewRegNumberPlates/"
              rel="noopener noreferrer"
              className="icon-facebook"
            >
              <svg
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2144"
                width="200"
                height="200"
              >
                <path
                  d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z"
                  p-id="2145"
                  fill="#ffffff"
                ></path>
              </svg>
              Facebook  
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/newreg_ltd"
              rel="noopener noreferrer"
              className="icon-instgram"
            >
              <svg
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3122"
                width="200"
                height="200"
              >
                <path
                  d="M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9z m0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zM725.5 250.7c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9c-0.1-26.6-21.4-47.9-47.9-47.9z"
                  p-id="3123"
                  fill="#ffffff"
                ></path>
                <path
                  d="M911.8 512c0-55.2 0.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-0.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-0.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9 0.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165z m-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                  p-id="3124"
                  fill="#ffffff"
                ></path>
              </svg>
              Instagram  
            </a>
            <a
              target="_blank"
              href="https://www.youtube.com/channel/UClVsPoZwHof3D7DB_tKC_MQ"
              rel="noopener noreferrer"
              className="icon-youtube"
            >
              <svg
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3967"
                width="200"
                height="200"
              >
                <path
                  d="M960 509.2c0-2.2 0-4.7-0.1-7.6-0.1-8.1-0.3-17.2-0.5-26.9-0.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8-12.8-47.9-50.4-85.6-98.3-98.5-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-0.2-26.8-0.3-38.4-0.4H497.3c-11.6 0.1-24.5 0.2-38.4 0.4-39.7 0.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2-47.8 12.8-85.5 50.5-98.3 98.5-6.1 22.6-10.4 52.7-13.4 88.8-2.2 26.2-3.6 54-4.4 81.9-0.3 9.7-0.4 18.8-0.5 26.9 0 2.9-0.1 5.4-0.1 7.6v5.6c0 2.2 0 4.7 0.1 7.6 0.1 8.1 0.3 17.2 0.5 26.9 0.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9 0.2 26.8 0.3 38.4 0.4H526.7c11.6-0.1 24.5-0.2 38.4-0.4 39.7-0.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9 0.3-9.7 0.4-18.8 0.5-26.9 0-2.9 0.1-5.4 0.1-7.6V512v-2.8z m-72 5.2c0 2.1 0 4.4-0.1 7.1-0.1 7.8-0.3 16.4-0.5 25.7-0.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7 0.2-26.4 0.3-37.8 0.3h-28.6c-11.4-0.1-24.1-0.2-37.8-0.3-39.1-0.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-0.3-9.3-0.4-18-0.5-25.7 0-2.7-0.1-5.1-0.1-7.1v-3-1.8c0-2.1 0-4.4 0.1-7.1 0.1-7.8 0.3-16.4 0.5-25.7 0.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-0.2 26.4-0.3 37.8-0.3h28.6c11.4 0.1 24.1 0.2 37.8 0.3 39.1 0.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9 0.3 9.3 0.4 18 0.5 25.7 0 2.7 0.1 5.1 0.1 7.1v4.8z"
                  p-id="3968"
                  fill="#ffffff"
                ></path>
                <path
                  d="M423 646l232-135-232-133z"
                  p-id="3969"
                  fill="#ffffff"
                ></path>
              </svg>
              Youtube  
            </a>
            <a
              target="_blank"
              href="https://g.page/r/CXW630dcpPktEAE"
              rel="noopener noreferrer"
              className="icon-google"
            >
              <svg
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4828"
                width="200"
                height="200"
              >
                <path
                  d="M879.5 470.4c-0.3-27-0.4-54.2-0.5-81.3h-80.8c-0.3 27-0.5 54.1-0.7 81.3-27.2 0.1-54.2 0.3-81.2 0.6v80.9c27 0.3 54.2 0.5 81.2 0.8 0.3 27 0.3 54.1 0.5 81.1h80.9c0.1-27 0.3-54.1 0.5-81.3 27.2-0.3 54.2-0.4 81.2-0.7v-80.9c-26.9-0.2-54.1-0.2-81.1-0.5zM349.5 470.8c-0.1 32.3 0 64.7 0.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-0.7-181.3-0.6-271.9-0.3z"
                  p-id="4829"
                  fill="#ffffff"
                ></path>
              </svg>
              google  
            </a>
          </div>
          <div className={styles.payments}>

            <img
              src={imgMC}
              className="float-right lazyloaded"
              alt=""
              style={{ width: "undefined", height: "20px" }}
            />

            <img
              src={imgVS}
              className="float-right lazyloaded"
              alt=""
              style={{ width: "65px", height: "20px" }}
            />
          </div>
        </div>
        <div className={styles.policy + " " + styles.container}>
          <div className="company-number col s12 m6">
            @New Reg Limited 2023 | VAT No: 604 5464 55 | Company No. 03143909
          </div>
          <div className="privacy-policy col s12 m6">
            <a
              href="https://www.newreg.co.uk/services/privacy_policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy policy
            </a>{" "}
            |{" "}
            <a
              href="https://www.newreg.co.uk/cookie_policy"
              target="_blank"
              rel="noreferrer"
            >
              Cookie policy
            </a>{" "}
            |{" "}
            <a
              href="https://www.newreg.co.uk/services/terms_and_conditions"
              target="_blank"
              rel="noreferrer"
            >
              Terms & conditions
            </a>{" "}
            |{" "}
            <a
              target="_blank"
              href="https://www.newreg.co.uk/help/regulations/cnda-code-of-practice"
              rel="noreferrer"
            >
              Code of practice
            </a>
          </div>
        </div>
        <div className={styles.dvla}>
          <div className={styles.container}>
            <span
              style={{ fontSize: "13px", display: "flex", textAlign: "left" }}
            >
              DVLA is a registered trade mark of the Driver & Vehicle Licensing
              Agency. New Reg is not affiliated to the DVLA or DVLA Personalised
              Registrations. New Reg is a recognised seller of unissued
              Government stock.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Footer, Footer as default };
